export const workflowInteractionDest = {
    condition: 'condition',
    group: 'group',
    interaction: 'interaction'
  };
